import { Brand, Site } from '@snapchat/mw-common';

import { contentfulSpaceIds } from './spaceIds';

/** Brand names for the contentful spaces under MWP. Undefined if the space is not a brand space. */
export const contentfulSpaceBrands: Partial<Record<Site, Brand | undefined>> = {
  [Site.A523]: Brand.SNAP,
  [Site.AR]: Brand.SNAP,
  [Site.CAREERS]: Brand.SNAP,
  [Site.CITIZEN]: Brand.SNAP,
  [Site.CREATORS]: Brand.SNAPCHAT,
  [Site.DIVERSITY]: Brand.SNAP,
  [Site.EDUCATORS]: Brand.SNAPCHAT,
  [Site.ENG_BLOG]: Brand.SNAP,
  [Site.EXPERIENCE]: Brand.SNAP,
  [Site.FOR_BUSINESS]: Brand.SNAPCHAT,
  [Site.NEWSROOM]: Brand.SNAPCHAT,
  [Site.PARENTS]: Brand.SNAPCHAT,
  [Site.TRUST]: Brand.SNAP,
  [Site.AVALON]: Brand.SPECTACLES,
  [Site.SNAP]: Brand.SNAP,
};

/** Mapping of space IDs to their corresponding brand name. */
export const brandBySpaceId = Object.entries(contentfulSpaceIds).reduce((acc, [site, spaceId]) => {
  acc[spaceId] = contentfulSpaceBrands[site as Site];
  return acc;
}, {} as Record<string, Brand | undefined>);
